import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs, Pagination, Autoplay, Keyboard } from 'swiper/modules';
import * as TopConst from '../features/top/hoc/TopConst';
import { columnInfo } from '@/assets/Const';
import topicsTitle from '@/assets/topics_title.png';
import serviceTitle from '@/assets/service_title.png';
import columnTitle from '@/assets/column_title.png';
import IconCircleArrow from '@/assets/icon_expand_circle_down.svg';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/pagination';
import '../components/SwiperWithThmbs/swiperSyle.css';
import { useOmiseCraftStaticContentsUrl } from '@/utility/Helper';
import axios from 'axios';
import ImageProperty from '@/assets/top/property.png';
import ImagePropertySp from '@/assets/top/property_sp.png';
import ImageInteriorMatching from '@/assets/top/interior_matching.png';
import ImageInteriorMatchingSp from '@/assets/top/interior_matching_sp.png';
import ImageColumn from '@/assets/top/column.png';
import ImageColumnSp from '@/assets/top/column_sp.png';
import ImagePropertySupportBanar from '@/assets/top/property_support.png';
import ImagePropertySupportBanarSp from '@/assets/top/property_support_sp.png';
import { useAtomValue } from 'jotai';
import { SwiperModule } from 'swiper/types';
import { ConfigContext } from '@/config';
import { SignUpFab } from '@/components/SignUpFab';
import { AuthAtoms } from '@/features/login/hoc/AuthAtom';
import CloseIcon from '@/assets/close.svg?react';
import TopModals from '@/components/TopModals';
import { useGetMember } from '@/apis/core/user';
import { isQualified } from '@/utility/qualified';

// 画像ファイルのパスを指定
type notification = {
  id: string;
  tag: string;
  date: string;
  title: string;
  text: string;
};
const defaultNotification = {
  id: '',
  tag: '',
  date: '',
  title: '',
  text: ''
};

// メイン/サムネ共通設定
const basisSwiperOption = {
  mousewheel: true,
  keyboard: true
};

export function Page() {
  const omiseCraftStaticContentsUrl = useOmiseCraftStaticContentsUrl();
  const [isNotificatePopupOpen, setIsNotificatePopupOpen] = useState(false);
  const [notifications, setNotifications] = useState<notification[]>([]);
  const [notification, setNotification] = useState<notification>(defaultNotification);
  const navigate = useNavigate();
  const isAuth = useAtomValue(AuthAtoms.isAuth);
  const getMember = useGetMember(undefined, false, { enabled: isAuth });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tempDate = new Date();
        const fileParams = tempDate.getTime();
        const url = omiseCraftStaticContentsUrl + '/news/news.json?' + fileParams;

        const response = await axios.get(url, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        setNotifications(response.data.slice(0, 3));
      } catch (error) {
        console.error('reading error:', error);
      }
    };

    fetchData();
  }, []);

  const togglePopup = (id: string) => {
    const obj = notifications.find((notification) => notification.id === id);

    if (obj) {
      setIsNotificatePopupOpen(!isNotificatePopupOpen);
      setNotification(obj);
    }
  };

  // 各サービス機能ページへの遷移
  const moveService = (path: string) => {
    navigate(path);
  };

  const notificationClass = 'flex flex-col justify-center md:mb-[40px] mb-[30px] md:mx-32 mx-5 relative';
  const notificationTagClass =
    'bg-contents md:text-sub text-sm md:font-bold border border-main md:w-[170px] h-6 w-[145px] rounded-[27px] md:mb-auto mb-[15px]';
  const notificationButtonClass =
    'bg-background md:absolute md:bottom-[189px] md:left-[830px] text-sub font-bold md:w-[170px] h-[30px] w-grid-4col rounded-[27px] flex justify-center items-center md:mb-auto md:mx-auto mb-[30px] mx-[40px]';

  const closeButtonClass = 'absolute top-[10px] right-[10px]';
  return (
    <div className="">
      <TopModals />
      <div className="max-w-[1366px] md:h-[385px] md:mx-auto md:mb-[50px] mb-[40px]">
        <DispSwiperItem
          type="ad"
          spaceBetween={20}
          slidesPerView1={'auto'}
          slidesPerView2={1.575}
          slidesPerView3={1.75}
          centeredSlides={true}
          loop={true}
          isDispalyPropertySupport={isAuth && getMember.isSuccess && isQualified(getMember.data?.qualifiedRank)}
          paginationMergin="mt-[40px]"
          moduleList={[FreeMode, Navigation, Thumbs, Pagination, Keyboard, Autoplay]}
        />
      </div>

      <div className="mx-auto max-h-fit h-fit md:w-[1230px] w-[350px] md:h-[257px] bg-contents rounded-[15px] relative">
        <div className="flex flex-col md:flex-row md:mb-[30px]">
          <img
            src={topicsTitle}
            className="md:mt-[18px] mt-[30px] w-[141px] h-[58px] md:ml-32 ml-[105px]"
            alt="お知らせ"
          />
          <h3 className="text-main md:ml-[30px] flex items-center h-6 md:mt-[38px] ml-[144px] md:mb-auto mb-[30px]">
            お知らせ
          </h3>
        </div>

        <div className={notificationClass}>
          {notifications.map((notification) => (
            <div className="md:flex mb-[15px]" key={notification.id}>
              <div className="flex">
                <div className={notificationTagClass}>{notification.tag}</div>
                <div className="md:mx-[30px] mx-5">{notification.date}</div>
              </div>
              <div
                className="cursor-pointer md:w-[672px] md:line-clamp-1 line-clamp-3 md:h-5 text-left"
                onClick={() => togglePopup(notification.id)}
                onKeyDown={() => togglePopup(notification.id)}
              >
                {notification.title}
              </div>
            </div>
          ))}
        </div>

        <div className="md:h-[30px] h-[60px]">
          <button className={notificationButtonClass} onClick={() => moveService('/news')}>
            もっと見る
          </button>
        </div>

        {isNotificatePopupOpen && (
          <div
            className="news-modal fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-60 z-50 cursor-pointer"
            onClick={() => setIsNotificatePopupOpen(false)}
            onKeyDown={() => setIsNotificatePopupOpen(false)}
          >
            <div className="bg-white md:w-2grid md:h-[375px] w-grid-3col pb-[20px] rounded-[15px] relative">
              <button className={closeButtonClass} onClick={() => setIsNotificatePopupOpen(false)}>
                <CloseIcon width={30} height={30} className="bg-main rounded-full fill-contents" />
              </button>
              <div className="md:mx-[100px] md:my-[60px] m-5 text-left">
                <h2 className="md:w-grid-2col w-[240px] text-main md:mb-[30px] mb-5 md:line-clamp-1 line-clamp-2">
                  {notification.title}
                </h2>
                <p
                  className="text-base max-h-[200px] pb-[20px] !overflow-auto overflow-y-scroll"
                  dangerouslySetInnerHTML={{ __html: notification.text }}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="mx-auto md:mt-[60px] mt-[40px] max-h-fit h-fit md:w-grid-full w-[310px]">
        <img src={serviceTitle} className="mx-auto" alt="サービス" />
        <h3 className="text-main mb-[30px]">サービス</h3>
        <div className="flex flex-wrap justify-start gap-[30px]">
          {TopConst.serviceItems.map((item) => (
            <div key={item.title}>
              <DispServiceItem item={item} onClick={moveService} />
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-[1366px] w-full mx-auto">
        <img src={columnTitle} className="mt-[20px] mx-auto" alt="コラム" />
        <h3 className="text-main">コラム</h3>
        <div className="mt-[30px] ml-[30px] mx-auto">
          <DispSwiperItem
            type="column"
            spaceBetween={30}
            slidesPerView1="auto"
            slidesPerView2="auto"
            slidesPerView3="auto"
            centeredSlides={false}
            loop={false}
            paginationMergin="mt-[30px]"
            moduleList={[FreeMode, Navigation, Thumbs, Pagination, Keyboard]}
          />
        </div>
      </div>
      <div>{!isAuth && <SignUpFab />}</div>
    </div>
  );
}

// Swiper表示の共通化
const DispSwiperItem = ({
  type,
  spaceBetween,
  slidesPerView1,
  slidesPerView2,
  slidesPerView3,
  centeredSlides,
  loop,
  isDispalyPropertySupport,
  paginationMergin,
  moduleList
}: {
  type: string;
  spaceBetween: number;
  slidesPerView1: number | 'auto';
  slidesPerView2: number | 'auto';
  slidesPerView3: number | 'auto';
  centeredSlides: boolean;
  loop: boolean;
  isDispalyPropertySupport?: boolean | false;
  paginationMergin: string;
  moduleList: SwiperModule[];
}) => {
  const pagenationClass = 'swiper-pagination relative ' + paginationMergin;

  const config = useContext(ConfigContext);
  const omiseCraftStaticColumnsUrl = config?.omiseCraftStaticColumnsUrl ?? '';

  // 広告
  const advertisements = [
    // 物件選定サポート
    {
      imageSrc: ImagePropertySupportBanar,
      imageSrcSp: ImagePropertySupportBanarSp,
      id: '3',
      link: '/property/selection',
      url: undefined
    },
    // 物件が続々登場中！
    {
      imageSrc: ImageProperty,
      imageSrcSp: ImagePropertySp,
      id: '1',
      link: '/properties/prefectures',
      url: undefined
    },
    // 内装会社マッチング
    {
      imageSrc: ImageInteriorMatching,
      imageSrcSp: ImageInteriorMatchingSp,
      id: '2',
      link: '/design',
      url: undefined
    },
    // コラムを見る
    { imageSrc: ImageColumn, imageSrcSp: ImageColumnSp, id: '4', link: undefined, url: omiseCraftStaticColumnsUrl }
  ];

  const filteredAdvertisements = advertisements.filter(
    (ad) => isDispalyPropertySupport || ad.link !== '/property/selection'
  );

  return (
    <Swiper
      {...basisSwiperOption}
      pagination={{
        el: '.swiper-pagination',
        clickable: true
      }}
      spaceBetween={spaceBetween}
      slidesPerView={'auto'}
      centeredSlides={centeredSlides}
      rewind={loop}
      className="swiper_main mb-5 mx-auto"
      id={type}
      breakpoints={{
        429: { slidesPerView: slidesPerView1 },
        1230: { slidesPerView: slidesPerView2 },
        1366: { slidesPerView: slidesPerView3 }
      }}
      keyboard={true}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false
      }}
      modules={moduleList}
    >
      {type === 'ad' && (
        <React.Fragment>
          {filteredAdvertisements.map((image, index) => (
            <SwiperSlide key={index} className="md:!w-[770px] !w-[310px]" id={'topSwiperImage' + image.id}>
              {image.link && (
                <a href={image.link}>
                  <img
                    src={image.imageSrc}
                    className="md:block hidden md:w-[770px] md:h-[290px] rounded-[15px]"
                    alt="イメージ画像"
                  />
                  <img
                    src={image.imageSrcSp}
                    className="md:hidden block w-[310px] h-[290px] rounded-[15px]"
                    alt="SPイメージ画像"
                  />
                </a>
              )}
              {image.url && (
                <a href={image.url} target="_blank" rel="noopener">
                  <img
                    src={image.imageSrc}
                    className="md:block hidden md:w-[770px] md:h-[290px] rounded-[15px]"
                    alt="イメージ画像"
                  />
                  <img
                    src={image.imageSrcSp}
                    className="md:hidden block w-[310px] h-[290px] rounded-[15px]"
                    alt="SPイメージ画像"
                  />
                </a>
              )}
            </SwiperSlide>
          ))}
        </React.Fragment>
      )}

      {type === 'column' && (
        <React.Fragment>
          {columnInfo.map((item) => {
            return (
              <SwiperSlide
                key={item.id}
                className="bg-contents rounded-[15px] w-grid-4col md:mt-[30px] overflow-hidden"
              >
                <a href={omiseCraftStaticColumnsUrl + item.link} target="_blank" rel="noopener">
                  <img src={item.imageSrc} className="w-[270px] h-[200px]" />
                  <div className="mx-[31px] mt-[30px]">
                    <div className="mb-5 h-[53px]">
                      <h2 className="text-main text-xl font-bold line_ellipses_2">{item.title}</h2>
                    </div>
                    <div className="mb-3 h-[64px]">
                      <p className="text-left leading-7 text-sm line_ellipses_3">{item.description}</p>
                    </div>
                  </div>
                  <p className="w-[20px] h-[20px] ml-auto mr-[10px] mb-[10px]">
                    <img
                      className="iconExpandCircleDown w-[20px] h-[20px] color-svg-contents -rotate-90"
                      src={IconCircleArrow}
                      alt="リンク"
                    />
                  </p>
                </a>
              </SwiperSlide>
            );
          })}
        </React.Fragment>
      )}
      <div className={pagenationClass}></div>
    </Swiper>
  );
};

// サービス表示の共通化
const DispServiceItem = ({ item, onClick }: { item: TopConst.serviceItem; onClick: (type: string) => void }) => (
  <div
    className="bg-contents md:w-grid-3col w-[310px] h-[214px] rounded-[15px] md:mb-[30px] mb-[10px] overflow-hidden cursor-pointer"
    onClick={() => onClick(item.path)}
    onKeyDown={() => onClick(item.path)}
  >
    <img src={item.imageSrc} className="md:mt-[30px] mt-5 mb-[15px] md:mx-[160px] mx-[130px]" />
    <h2 className="mb-5">{item.title}</h2>
    <p className="mx-[30px] text-left mb-3 h-10">{item.description}</p>
    <p className="w-[20px] h-[20px] font-bold ml-auto mr-[10px]">
      <img
        className="iconExpandCircleDown w-[20px] h-[20px] color-svg-contents -rotate-90"
        src={IconCircleArrow}
        alt="リンク"
      />
    </p>
  </div>
);
export default Page;
